"use client"

import { ReactNode } from 'react'
import { PostcodeProvider } from '@/contexts/postcode-context'

export function Providers({ children }: { children: ReactNode }) {
  return (
    <PostcodeProvider>
      {children}
    </PostcodeProvider>
  )
}
